import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { StaticImage } from "gatsby-plugin-image";

const responsive = {
  tablet: {
    breakpoint: { max: 900, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1.5,
  },
};

function Partner(props) {
  return (
    <div className="tekrevol_partner tekrevol_gray_bg p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={11}
            xxl={11}
            className="tekrevol_partner_title"
          >
            <div className="example" data-text="Clientele">
              <h2>Our Esteemed Clientele</h2>
            </div>
            <p>
              We contribute to these partnership programs, supported by global
              technology experts. Partnering with industry leaders, we offer
              quality technology solutions that meet your business needs.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="tekrevol_partner_logo"
          >
            <div className="item_logo">
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-14.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-13.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-8.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-9.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-17.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-10.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-18.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-1.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-4.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-5.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-6.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-7.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-16.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-11.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-12.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-15.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-2.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
              <div className="logo_box">
                <StaticImage
                  src="../../images/partner/partner-3.webp"
                  alt="tekrevol_Partner"
                  className="img-fluid"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={262}
                  height={262}
                />
              </div>
            </div>
            <div className="item_logo_slide">
              <Carousel
                responsive={responsive}
                autoPlay={true}
                autoPlaySpeed={3000}
                infinite={true}
                arrows={false}
                className="carousel_featured"
              >
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-14.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-13.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-8.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-9.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-17.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-10.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-18.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-1.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-4.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-5.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-6.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-7.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-16.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-11.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-12.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-15.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-15.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
                <div className="logo_box">
                  <StaticImage
                    src="../../images/partner/partner-3.webp"
                    alt="tekrevol_Partner"
                    className="img-fluid"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={262}
                    height={262}
                  />
                </div>
              </Carousel>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Partner;
